import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Button} from "@mui/material";
import * as React from "react";
import {useState} from "react";

const DataDetailModal = (props) => {
    const [showModal, setShowModal] = useState(false);
    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <div><Button
            onClick={openModal}
            variant="outlined" size="small"
        >More</Button>
            <Modal
                hideBackdrop
                open={showModal}
                onClose={closeModal}>
                <Box sx={{...style}}>
                <pre>
                  <Typography id="modal-modal-description" sx={{mt: 2, ml: 2}}>
                    {JSON.stringify(props.selectedRow, null, 2)}
                 </Typography>
                </pre>
                    <Button variant="outlined"
                            onClick={closeModal}>Close</Button>
                </Box>
            </Modal>
        </div>
    )
}
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 700,
    bgcolor: 'background.paper',
    border: '1px solid',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
}
export default DataDetailModal;